export default {
  "content": "<g clip-path=\"url(#clip0_431_53617)\" fill=\"#3F4450\"><path d=\"M20.38 0H3.62A3.62 3.62 0 000 3.62v9.76A3.62 3.62 0 003.62 17h16.76A3.618 3.618 0 0024 13.38V3.62A3.619 3.619 0 0020.38 0zM22 13.38A1.63 1.63 0 0120.38 15H3.62A1.63 1.63 0 012 13.38V3.62A1.63 1.63 0 013.62 2h16.76A1.63 1.63 0 0122 3.62v9.76zM8 20h8a3 3 0 013 3H5a3 3 0 013-3zM13 18h-2v2h2v-2z\"/></g><defs><clipPath id=\"clip0_431_53617\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};